"use strict";
function kebabCase(str) {
    return str
        .replace(/([a-z])([A-Z])/g, '$1-$2') // Convert camelCase to kebab-case
        .replace(/[\s_\/]+/g, '-') // Replace spaces, underscores, and slashes with hyphens
        .toLowerCase();
}
class CpqCustomizer {
    constructor(config) {
        this.config = config;
        this.configurationData = null;
        // Validate that all properties in config are present and not null/undefined
        const missingKeys = Object.keys(this.config).filter(key => this.config[key] == null);
        if (missingKeys.length > 0) {
            console.error('initCpqPdp error: Missing required parameter(s):', missingKeys.join(', '));
        }
        this.config.addToCartButton.forEach(button => button.disabled = true);
        this.loadConfiguration();
        console.log("CPQ PDP initialized");
        this.config.addToCartButton.forEach(button => button.disabled = false);
    }
    enableCpqButtons(headerId, detailId) {
        const buttonsContainer = this.config.cpqButtonsContainer;
        const viewButton = buttonsContainer.querySelector('[name="cpq-view"]');
        const emailButton = buttonsContainer.querySelector('[name="cpq-email"]');
        const saveButton = buttonsContainer.querySelector('[name="cpq-save"]');
        const printButton = buttonsContainer.querySelector('[name="cpq-print"]');
        buttonsContainer.style.display = 'flex';
        viewButton.onclick = () => {
            this.showConfigurationModal();
        };
        emailButton.onclick = () => {
            window.location.href = 'mailto:?subject=Omni Cheer Customized Design&body=Checkout this Omni Cheer custom product I designed: %0D%0A ' + encodeURIComponent(window.location.href + `&headerId=${headerId}&detailId=${detailId}`);
        };
        saveButton.onclick = async () => {
            const originalText = saveButton.textContent;
            saveButton.disabled = true;
            saveButton.textContent = 'Saving…';
            try {
                const response = await fetch('/a/cpq-api/save-design', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        headerId,
                        detailId,
                        name: this.config.productName,
                        url: `${this.config.productUrl}?headerId=${headerId}&detailId=${detailId}`
                    })
                });
                if (!response.ok) {
                    throw new Error('Save design request failed');
                }
                const responseText = await response.text();
                if (responseText) {
                    try {
                        const data = JSON.parse(responseText);
                        if (data.success === false) {
                            throw new Error(data.message || 'Unable to save design');
                        }
                    }
                    catch (parseError) {
                        console.warn('Unable to parse save design response:', parseError);
                    }
                }
                this.showSaveConfirmationModal();
            }
            catch (error) {
                console.error('Error saving design:', error);
                if (window.genericModal) {
                    window.genericModal.show('Unable to Save', 'Something went wrong while saving your design. Please try again.');
                }
                else {
                    alert('Something went wrong while saving your design. Please try again.');
                }
            }
            finally {
                saveButton.disabled = false;
                saveButton.textContent = originalText;
            }
        };
    }
    showConfigurationModal() {
        if (window.cpqViewModal) {
            window.cpqViewModal.show();
        }
        else {
            console.error('CPQ View Modal not found');
        }
    }
    showSaveConfirmationModal() {
        const modal = window.cpqSaveModal;
        if (modal && typeof modal.show === 'function') {
            modal.show();
            return;
        }
        if (window.genericModal) {
            window.genericModal.show('Save Design', 'Your design has been saved!');
        }
        else {
            alert('Your design has been saved!');
        }
    }
    updatePdp(config) {
        const details = config.details || [];
        console.log('Updating PDP with details:', details);
        const imageDetails = details.filter((item) => item.name.indexOf('Image') !== -1 && item.value);
        document.getElementById('cpq-custom-image')?.setAttribute('src', imageDetails[0]?.value || '');
        document.getElementById('cpq-custom-image-simple')?.setAttribute('src', imageDetails[0]?.value || '');
        imageDetails.reverse();
        var imageColumn = this.config.thumbnailColumn;
        var color = kebabCase(details.find((item) => item.name === 'Color')?.value || '');
        // show proper color thumbnails: hide any thumb whose data-color doesn't match `color` (case-insensitive)
        if (imageColumn && color) {
            const thumbs = imageColumn.querySelectorAll('.vg-thumb-item');
            const desired = kebabCase(color || '');
            thumbs.forEach(t => {
                const dataColor = kebabCase((t.dataset.color || ''));
                if (dataColor === desired) {
                    t.style.display = 'block';
                }
                else {
                    t.style.display = 'none';
                }
            });
        }
        var mainImageColumn = this.config.mainImageStage;
        imageDetails.forEach((item) => {
            if (imageColumn && mainImageColumn) {
                var guid = crypto.randomUUID();
                const thumbDiv = document.createElement('div');
                thumbDiv.className = 'vg-thumb-item';
                thumbDiv.style.setProperty('display', 'block');
                const img = document.createElement('img');
                img.src = item.value || '';
                img.width = 200;
                //img.height = 200;
                img.loading = 'lazy';
                thumbDiv.dataset.mediaId = guid;
                thumbDiv.appendChild(img);
                imageColumn.prepend(thumbDiv);
                const mainDiv = document.createElement('div');
                mainDiv.className = 'vg-main-item';
                mainDiv.id = `Media-${guid}`;
                const productMediaDiv = document.createElement('div');
                productMediaDiv.className = 'product-media';
                //productMediaDiv.style.setProperty('--ratio', '1.0');
                productMediaDiv.setAttribute('data-media-id', guid);
                const mainImg = document.createElement('img');
                mainImg.src = item.value || '';
                mainImg.width = 3840;
                //mainImg.height = 3840;
                mainImg.className = 'product-media__image';
                mainImg.style.setProperty('--focal-point', '50.0% 50.0%');
                productMediaDiv.appendChild(mainImg);
                mainDiv.appendChild(productMediaDiv);
                mainImageColumn.prepend(mainDiv);
            }
        });
        initVerticalGallery();
        // hide color options
        this.config.colorOptions.forEach(option => {
            option.style.display = 'none';
        });
        // set color label and update hidden variant for no-size products
        const colorName = details.find((item) => item.name === 'Color')?.value || '';
        if (!!this.config.colorLabel)
            this.config.colorLabel.textContent = colorName;
        if (colorName) {
            const allColorInputs = Array.from(document.querySelectorAll('.color-option input[type="radio"]'));
            allColorInputs.forEach(input => input.checked = false);
            const match = allColorInputs.find(input => input.dataset.colorName === colorName);
            if (match) {
                match.checked = true;
                const variantId = match.dataset.variantId;
                if (variantId) {
                    const hiddenVariantInput = match.closest('[id^="single-order-block-"]')?.querySelector('input[id^="main-variant-id-"]');
                    if (hiddenVariantInput) {
                        hiddenVariantInput.value = variantId;
                    }
                }
            }
        }
        const quantity = Number(details.find((item) => item.name === 'Web Quantity')?.value || '1');
        // set quantity
        document.querySelectorAll('.cpq-quantity').forEach(el => {
            el.textContent = quantity.toString();
        });
        const qtyInput = document.querySelector('.qty-input');
        if (qtyInput) {
            qtyInput.value = quantity.toString();
        }
        document.querySelectorAll('.cpq-price').forEach(el => {
            const rawPrice = config.price;
            const numericPrice = Number(rawPrice ?? 0) * quantity;
            const formattedPrice = '$' + numericPrice.toFixed(2);
            el.textContent = formattedPrice;
        });
        //  show remove configuration link
        document.getElementById('remove-configuration')?.style.setProperty('display', 'block');
    }
    static hasMinQty(minQty, quantity) {
        if (quantity < minQty) {
            if (window.genericModal) {
                window.genericModal.show('Customization Issue', `There is a minimum order quantity on this specific customization type you have added to your product. Please update your quantity to ${minQty} or more if you would like to add this product to your cart.`);
            }
            return false;
        }
        return true;
    }
    setupNewConfiguration(cpqPayload, button) {
        const originalText = button.textContent;
        button.textContent = 'Loading Customizer...';
        button.disabled = true;
        fetch("/a/cpq-api/prepare-for-interactive-configuration", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(cpqPayload)
        })
            .then(response => response.json())
            .then(data => {
            if (data.success) {
                window.location.href = data.url;
            }
            else {
                alert("Error preparing customization. Please try again.");
                console.error('Error preparing for interactive configuration:', data.message);
                button.textContent = originalText;
                button.disabled = false;
            }
        })
            .catch(error => {
            console.error('Error calling CPQ proxy:', error);
            alert('An error occurred. Please try again.');
            button.textContent = originalText;
            button.disabled = false;
        });
        button.textContent = originalText;
        button.disabled = false;
    }
    loadConfiguration() {
        const button = this.config.cpqButton;
        const urlParams = new URLSearchParams(window.location.search);
        const headerId = urlParams.get('headerId');
        const detailId = urlParams.get('detailId');
        if (!headerId || !detailId)
            return;
        const response = fetch('/a/cpq-api/load-configuration', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ headerId, detailId, productId: this.config.productId })
        })
            .then(async (response) => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            return data;
        })
            .then(data => {
            console.log('Fetched data:', data);
            if (data.success) {
                if (data.configuration?.details?.length === 0) {
                    window.history.replaceState({}, document.title, window.location.pathname); // Remove query params
                    window.location.reload(); // Reload page without query params
                    return;
                }
                // Store configuration data for later use
                this.configurationData = data.configuration || null;
                // Prepare images and details for modal
                const details = data.configuration?.details || [];
                const imageDetails = details.filter((item) => item.name && item.name.indexOf('Image') !== -1 && item.value);
                const imageUrls = imageDetails.map((item) => item.value);
                // Get color to also show original product images
                const colorItem = details.find((item) => item.name === 'Color');
                document.querySelectorAll(`.color-option input[value="${colorItem?.value}"]`)[0]?.click();
                const color = kebabCase(colorItem?.value || '');
                // Get original product images for the selected color
                const thumbnailColumn = this.config.thumbnailColumn;
                if (thumbnailColumn && color) {
                    const thumbs = thumbnailColumn.querySelectorAll('.vg-thumb-item');
                    thumbs.forEach(t => {
                        const dataColor = kebabCase((t.dataset.color || ''));
                        if (dataColor === color) {
                            const img = t.querySelector('img');
                            if (img && img.src && !imageUrls.includes(img.src)) {
                                imageUrls.push(img.src);
                            }
                        }
                    });
                }
                // Filter variant rows based on color
                if (colorItem?.value) {
                    const variantRows = document.querySelectorAll('.variant-row');
                    variantRows.forEach(row => {
                        const rowColorMatch = row.dataset.colorMatch || '';
                        if (rowColorMatch === colorItem.value) {
                            row.classList.add('is-visible');
                        }
                        else {
                            row.classList.remove('is-visible');
                        }
                    });
                }
                // Initialize modal with images and details
                if (window.cpqViewModal) {
                    window.cpqViewModal.setData(imageUrls, details);
                }
                this.enableCpqButtons(headerId, detailId);
                button.textContent = 'Edit Configuration';
                // Process data as needed
                this.updatePdp(data.configuration);
                var detailsTransform = {};
                data.configuration?.details.forEach(item => {
                    let key = item.name;
                    if (!item.visible) {
                        key = '_' + key;
                    }
                    detailsTransform[key] = item.value;
                });
                detailsTransform._cpqCustomizationDetails = JSON.stringify(data.configuration?.rawDetails) || [];
                detailsTransform._cpqPricing = data.configuration?.cpqPricing;
                detailsTransform._hash = data.configuration?.hash;
                this.config.addToCartButton.forEach(button => button.dataset.details = JSON.stringify(detailsTransform));
                // SPO: Reveal hidden elements after configuration is loaded
                const blockWrapper = this.config.blockWrapper;
                if (blockWrapper && blockWrapper.dataset.spo === 'true') {
                    const spoSize = blockWrapper.querySelector('.spo-hideable-size');
                    const spoCart = blockWrapper.querySelector('.spo-hideable-cart');
                    // Show size grid (if present) and add-to-cart button
                    if (spoSize)
                        spoSize.style.display = '';
                    if (spoCart) {
                        spoCart.style.display = '';
                        spoCart.textContent = 'Add to Bag';
                    }
                    // Color stays hidden — it's set by the CPQ response
                    // Qty row stays hidden for no-sizes SPO — quantity comes from CPQ
                }
                this.config.addToCartButton.forEach(button => button.dataset.details = JSON.stringify(detailsTransform));
            }
            else {
                alert(`Error fetching configuration: ${data.message}`);
            }
        })
            .catch(error => {
            console.error('Fetch error:', error);
        });
    }
}
